// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"d6883e20","212":"6c60c158","238":"e7250fe4","312":"378e3223","365":"c54e54c4","825":"375003b9","948":"3428cb60"}[chunkId] + ".chunk.js";
};